import React from 'react';
import PropTypes from 'prop-types';

class AppetiteAccordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    const height = this.accordion.clientHeight;
    this.setState({ height });
  }

  render() {
    return (
      <section
        id="appetite"
        ref={accordion => (this.accordion = accordion)}
        className={`accordion ${this.props.isAppetiteAccordionOpen ? 'accordion__open' : ''} `}
      >
        {this.props.children}
      </section>
    );
  }
}

export default AppetiteAccordion;



// WEBPACK FOOTER //
// ./src/components/AppetiteAccordion.js